import './lib/sentry';
import 'nprogress/nprogress.css';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import App from './App';
import { AuthProvider } from './contexts/FirebaseContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { ParametersProvider } from './contexts/ParametersContext';
import ErrorBoundary from './components/ErrorBoundary';
import DevRoleWrapper from './components/DevRoleWrapper';

// Fix: @material-table/core uses react-dnd's HTML5 backend which calls removeChild
// on drag-preview DOM nodes that may already be detached in Electron 118 / Chromium 118.
const _removeChild = Node.prototype.removeChild;
Node.prototype.removeChild = function rmc(child) {
  if (child.parentNode !== this) return child;
  return _removeChild.call(this, child);
};

ReactDOM.render(
  <StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <StyledEngineProvider injectFirst>
          <SettingsProvider>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <AuthProvider>
                <DevRoleWrapper>
                  <ParametersProvider>
                    <App />
                  </ParametersProvider>
                </DevRoleWrapper>
              </AuthProvider>
            </BrowserRouter>
          </SettingsProvider>
        </StyledEngineProvider>
      </HelmetProvider>
    </ErrorBoundary>
  </StrictMode>,
  document.getElementById('root')
);
